export default __webpack_public_path__ + "static/media/en.1685f261.md";